import clsx from 'clsx';
import React, { useContext, type ReactNode } from 'react';
import { Icon } from '../../Icon';
import { AccordionContext } from './AccordionContext';

/**
 * Summary button to toggle open and close
 */
export const AccordionSummary = React.forwardRef<
  HTMLButtonElement,
  { children: ReactNode }
>(({ children }, ref) => {
  const { isOpen, handleToggle } = useContext(AccordionContext);
  return (
    <button
      ref={ref}
      type='button'
      className={clsx('hg-accordion__summary', { 'is-open': isOpen })}
      onClick={handleToggle}
      aria-expanded={isOpen}
    >
      {children}
      <Icon
        icon='ChevronDown'
        size='large'
        className='hg-accordion__summary-icon'
      />
    </button>
  );
});
AccordionSummary.displayName = 'Accordion.Summary';
